var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg003(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.667,
    height: 33,
    viewBox: "0 0 78.667 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-924.277 -127.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(924.277 127.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M933.32,127.347h5.4v23.418h2.551v.464h-5.333v-2.882h-.066a4.451,4.451,0,0,1-4.372,3.345c-3.909,0-7.221-3.61-7.221-7.652,0-3.975,3.213-7.453,6.989-7.453a4.537,4.537,0,0,1,4.538,3.08h.066V127.811H933.32Zm-1.789,23.882c3.677,0,4.339-3.577,4.339-6.492,0-3.412-.232-4.969-1.159-6.161a3.928,3.928,0,0,0-3.312-1.524c-3.08,0-3.809,2.551-3.809,6.592C927.589,148.248,927.887,151.229,931.531,151.229Z",
    transform: "translate(-924.277 -127.347)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M1141.754,152.86h2.551V139.577h-2.551v-.464h5.4V152.86h2.55v.464h-7.949Zm3.909-23.22a1.756,1.756,0,1,1-1.756,1.756A1.767,1.767,0,0,1,1145.663,129.64Z",
    transform: "translate(-1122.907 -129.441)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M1237.305,238.954h8.016v.464H1242.6l4.273,10.4,4.439-10.4H1248.6v-.464h5.035v.464h-1.789l-6.26,14.839-6.028-14.839h-2.252Z",
    transform: "translate(-1210.178 -229.282)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M1454.353,248.261a3.959,3.959,0,0,1-2.484.828,2.9,2.9,0,0,1-3.279-2.584h-.066c-.331.828-1.093,2.584-4.372,2.584-3.677,0-4.273-1.855-4.273-3.213,0-3.114,2.716-3.412,5.167-4.207,2.948-.961,3.61-1.159,3.61-3.809,0-2.12-.364-3.412-2.551-3.412-1.457,0-2.517.5-2.517,1.623,0,.762.2,1.557.2,1.921a1.142,1.142,0,0,1-1.292,1.093c-1.458,0-1.623-.6-1.623-1.424,0-1.954,1.789-3.677,5.167-3.677,4.074,0,5.366,2.219,5.366,4.571V246.8c0,1.259.431,1.623,1.159,1.623a2.826,2.826,0,0,0,1.524-.53Zm-5.8-7.751h-.066c-.033.265-.431.6-1.093.861l-2.484.994a3.183,3.183,0,0,0-2.186,3.147c0,1.358.4,2.915,2.451,2.915,2.948,0,3.379-2.816,3.379-4.6Z",
    transform: "translate(-1395.195 -224.744)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M1617.606,248.86h2.551V235.577h-2.551v-.464h5.333v3.544h.066a5.958,5.958,0,0,1,5.7-3.909c2.915,0,4.935,1.358,4.935,4.439v9.672h2.551v.464h-7.95v-.464h2.551v-10.7c0-1.722-.8-2.948-2.517-2.948-2.849,0-5.267,2.65-5.267,6.161v7.486h2.551v.464h-7.95Z",
    transform: "translate(-1557.521 -225.441)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(924.401 154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 78.273,
    height: 2.968,
    transform: "translate(0 3.379)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 78.273,
    height: 0.575,
    transform: "translate(0 0)",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003);
export default __webpack_public_path__ + "static/media/003.e5dcc1a5e48e5b93f128436ad08ed49f.svg";
export { ForwardRef as ReactComponent };